import Icon from '@components/std-components/Icons'
import { PulseProgress } from '@components/UI-Components/svg'
import MdAdd from '@meronex/icons/md/MdAdd'
import MdRemove from '@meronex/icons/md/MdRemove'
import React from 'react'
import HeartContrastOutline from '@components/std-components/HeartContrastOutlineIcon'

export enum SAActionsType {
  basketInProgress = 'Basket toggle in progress',
  removeFromBasket = 'Remove a product from the basket',
  addToBasket = 'Add a product to the basket',
  removeFavourite = 'Remove a product from favourites',
  addFavourite = 'Add a product to favourites'
}

export interface ISAActions {
  actionType: SAActionsType
  iconSize?: number
  iconWidth?: number
  iconHeight?: number
  fillColor?: string
  strokeColor?: string
}

export const SAActions: React.FC<ISAActions> = ({
  actionType,
  iconSize,
  iconWidth,
  iconHeight,
  fillColor,
  strokeColor
}) => {
  switch (actionType) {
    case SAActionsType.basketInProgress:
      return <Icon imageSrc={PulseProgress} />
    case SAActionsType.removeFromBasket:
      return <MdRemove size={iconSize ?? 22} />
    case SAActionsType.addToBasket:
      return <MdAdd size={iconSize ?? 22} />
    case SAActionsType.removeFavourite:
      return (
        <HeartContrastOutline
          size={iconSize ?? 22}
          width={iconWidth ?? 22}
          height={iconHeight ?? 20}
        />
      )
    case SAActionsType.addFavourite:
      return (
        <HeartContrastOutline
          size={iconSize ?? 22}
          width={iconWidth ?? 22}
          height={iconHeight ?? 20}
          fillColor={fillColor ?? '#ffffff'}
          strokeColor={strokeColor ?? '#000000'}
        />
      )
    default:
      return null
  }
}
